module.exports = __webpack_public_path__ + "img/DNK.83be29f8.svg";